<template>
  <div class="m-0 p-0">
    <p
      class="m-0 worksansr"
      v-for="(item, key) in question.alternatives"
      :key="key"
      v-show="item.answer"
    >
      {{ item.label }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    category_id: [String, Number],
    question: Object,
  },
};
</script>
